// src/components/MyComponent/index.tsx
import { Platform } from 'react-native';

let ThermalPrinters;

if (Platform.OS === 'web') {
  ThermalPrinters = require('./ThermalPrinters.web').default;
} else {
  ThermalPrinters = require('./ThermalPrinters.native').default;
}

export default ThermalPrinters;
